import React from 'react';
import '../../../components/jds/jds.css';
import '../addPlans.css';

// Também é usado por AddCoupons (fora de .jds-scope), por isso traz o próprio escopo.
export function PlanFormWarnings({ planId, formik }) {
  if (!planId) return null;

  return (
    <div className="jds-scope">
      <div className="ap-notice ap-notice--warning" role="alert">
        <strong>Modo edição.</strong> Você está alterando um plano já
        cadastrado. Revise os dados antes de salvar.
      </div>
      <div className="ap-notice ap-notice--info" role="alert">
        <strong className="ap-notice-title">
          Valor do plano e o que pode ser editado
        </strong>
        <ul className="ap-notice-list">
          <li>
            Para cobrar outro valor, o caminho recomendado é{' '}
            <strong>criar um plano/cupom novo</strong>,
            conforme a estratégia comercial da operação.
          </li>
          <li>
            <strong>Os demais atributos</strong> do plano podem ser{' '}
            <strong>alterados normalmente</strong> aqui.
          </li>
        </ul>
      </div>
    </div>
  );
}
